import styled from 'styled-components';

import { SecondaryButton } from 'components/Buttons';
import { SaveButton } from 'styles/modals';

export const ActionsContainer = styled.div`
  button:first-child {
    margin-right: 10px;
  }
`;

export const ActionButton = styled(SecondaryButton)`
  font-size: 11px;
  line-height: 15px;
  padding: 5px 20px;
`;

// Cancel button acts as save in terms of look. It would be confusing in the component
// so i'm renaming it here
export const CancelButton = styled(SaveButton)``;
